import { BookOpen, Users, Wallet, Award, Video, Shield } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: Video,
    title: "Premium Video Courses",
    description: "High-quality video lessons from industry experts, covering in-demand skills.",
  },
  {
    icon: Award,
    title: "Earn Certificates",
    description: "Get verified certificates upon completion to boost your career prospects.",
  },
  {
    icon: Users,
    title: "Referral Program",
    description: "Earn up to ₦4,000 for every friend you refer who joins the platform.",
  },
  {
    icon: Wallet,
    title: "Easy Withdrawals",
    description: "Withdraw your earnings directly to your bank account or mobile money.",
  },
  {
    icon: BookOpen,
    title: "Lifetime Access",
    description: "Pay once and get unlimited access to all courses, forever.",
  },
  {
    icon: Shield,
    title: "Secure Payments",
    description: "Your payments are protected with bank-grade encryption technology.",
  },
];

const Features = () => {
  return (
    <section id="features" className="py-32 bg-background">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="text-center max-w-xl mx-auto mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-5">
            TERALEARN: Your Smart Choice
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Learn in-demand skills, earn certificates, and make money — all in one platform.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="w-12 h-12 rounded-xl bg-primary/8 flex items-center justify-center mx-auto mb-5 icon-pop">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
